import { getShortcuts, type ShortcutAction } from '../hooks/use-shortcut';

/** Localized key caps (DESIGN.md §17: "Ctrl" / "Strg", "Delete" / "Entf"). */
export interface KeyNames {
  mod: string;
  shift: string;
  alt: string;
  delete: string;
  insert: string;
  enter: string;
}

const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
const MAC_SYMBOLS: Readonly<Record<string, string>> = { mod: '⌘', shift: '⇧', alt: '⌥' };

/** One chord for display, e.g. `Mod+Shift+R` → `Ctrl+Shift+R` (`⌘⇧R` on macOS). */
export function formatChord(chord: string, names: KeyNames, mac = IS_MAC): string {
  const parts = chord.split('+').map((part) => {
    const lower = part.toLowerCase();
    if (mac && MAC_SYMBOLS[lower]) return MAC_SYMBOLS[lower];
    if (lower in names) return names[lower as keyof KeyNames];
    return part.length === 1 ? part.toUpperCase() : part;
  });
  return parts.join(mac ? '' : '+');
}

/** The first chord of a keymap action for menus and tooltips; undefined without a binding. */
export function shortcutText(action: ShortcutAction | undefined, names: KeyNames, mac = IS_MAC): string | undefined {
  const chord = action ? getShortcuts(action)[0] : undefined;
  return chord ? formatChord(chord, names, mac) : undefined;
}
